import * as React from 'react'
import type { SVGProps } from 'react'
function SvgSterblichkeitMaenner(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 93 93"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <path d="M82.6,10.2c-.3-.2-.7-.4-1.1-.4l-29.3.3c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h0l26-.3-23.7,23.8c-4.9-4.4-11.2-6.8-17.9-6.8s-13.9,2.8-18.9,7.8c-4.9,5.1-7.7,11.8-7.7,18.9s2.8,13.9,7.8,18.9c5.2,5.2,12.1,7.8,18.9,7.8s13.7-2.6,18.9-7.8c5.1-5.1,7.8-11.8,7.8-18.9s-2.4-12.9-6.8-17.8l23.5-23.5v25.7c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5V11.3c0-.4,0-.8-.4-1.1h0ZM53.5,73.3c-9.3,9.3-24.3,9.3-33.6,0-4.4-4.5-6.9-10.4-6.9-16.8s2.5-12.3,7-16.8c4.5-4.5,10.4-7,16.8-7s12.3,2.5,16.8,7,7,10.4,7,16.8-2.6,12.3-7.1,16.8Z" />
    </svg>
  )
}
export default SvgSterblichkeitMaenner
